// Title-screen music: four tracks to click through, played from client/music. Browsers block sound until the page is
// clicked, so the first click or key starts it (unless muted). The game's own music takes over on PLAY: stop() fades out.
const TRACKS = [
  { file: 'music/01-rain-over-kabukicho.mp3', title: 'Rain Over Kabukicho' },
  { file: 'music/02-lantern-circuit.mp3', title: 'Lantern Circuit' },
  { file: 'music/03-chrome-ronin.mp3', title: 'Chrome Ronin' },
  { file: 'music/04-shrine-after-midnight.mp3', title: 'Shrine After Midnight' },
];
const KEY = 'nk.titleMusic', VOLUME = 0.5;

const load = () => { try { return localStorage.getItem(KEY) === 'off'; } catch { return false; } };
const save = (muted: boolean) => { try { localStorage.setItem(KEY, muted ? 'off' : 'on'); } catch { /* private mode */ } };

export function startTitleMusic(): () => void {
  const $ = (id: string) => document.getElementById(id);
  const box = $('bgm'), title = $('bgm-title'), mute = $('bgm-mute');
  if (!box || !title || !mute) return () => {};
  const audio = new Audio(); audio.preload = 'none'; audio.volume = VOLUME;
  // automated browsers stay silent: tests must not depend on audio
  let i = 0, muted = load() || navigator.webdriver, started = false, stopped = false;

  const show = () => {
    title.textContent = TRACKS[i].title;
    const label = muted ? 'Play music' : 'Mute music';
    mute.setAttribute('aria-label', label); mute.title = label; mute.setAttribute('aria-pressed', String(muted));
    box.dataset.state = muted ? 'muted' : 'on';
    if (muted) box.classList.remove('playing');
  };
  // the equalizer animates only while the audio is actually playing
  audio.addEventListener('playing', () => { if (!muted) box.classList.add('playing'); });
  audio.addEventListener('pause', () => box.classList.remove('playing'));
  audio.addEventListener('ended', () => box.classList.remove('playing'));
  const play = () => {
    if (stopped || muted) return;
    started = true;
    if (!audio.src.endsWith(TRACKS[i].file)) audio.src = TRACKS[i].file;
    audio.play().catch(() => { started = false; }); // still blocked: the next click tries again
  };
  const go = (d: number) => { i = (i + d + TRACKS.length) % TRACKS.length; audio.src = TRACKS[i].file; show(); play(); };
  audio.addEventListener('ended', () => go(1));
  $('bgm-prev')?.addEventListener('click', () => go(-1));
  $('bgm-next')?.addEventListener('click', () => go(1));
  mute.addEventListener('click', () => {
    muted = !muted; save(muted); show();
    if (muted) audio.pause(); else play();
  });
  // a first click on PLAY or Join leaves the title screen at once, so it shouldn't start a download
  const firstGesture = (e: Event) => { if (!started && !(e.target as Element | null)?.closest?.('#create, #join')) play(); };
  document.addEventListener('pointerdown', firstGesture, true);
  document.addEventListener('keydown', firstGesture, true);
  show();

  return () => {
    if (stopped) return; stopped = true;
    document.removeEventListener('pointerdown', firstGesture, true);
    document.removeEventListener('keydown', firstGesture, true);
    const v0 = audio.volume, t0 = performance.now();
    const fade = () => {
      const k = Math.min(1, (performance.now() - t0) / 1200);
      audio.volume = v0 * (1 - k);
      if (k < 1) requestAnimationFrame(fade); else { audio.pause(); audio.removeAttribute('src'); audio.load(); }
    };
    fade();
  };
}
